import { useEffect, useState } from 'react';
import { Wifi, WifiOff, RefreshCw } from 'lucide-react';
import { useOnlineStatus } from '../hooks/useOnlineStatus';
import { showNotification } from './notificationUtils';

const OfflineNotification = () => {
  const { isOnline, wasOffline } = useOnlineStatus();
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    if (!isOnline) {
      setShowBanner(true);
      showNotification('warning', 'أنت الآن في وضع عدم الاتصال. سيتم حفظ طلباتك ومزامنتها عند عودة الاتصال.');
    } else if (wasOffline) {
      setShowBanner(true);
      showNotification('success', 'تم استعادة الاتصال! يمكنك متابعة التسوق.');
      // Auto hide after 3 seconds when back online
      const timer = setTimeout(() => setShowBanner(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [isOnline, wasOffline]);

  const handleRetry = () => {
    window.location.reload();
  };

  if (!showBanner) return null;

  return (
    <div
      className={`fixed bottom-4 left-4 right-4 z-50 transform transition-all duration-300 ${
        showBanner ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'
      } md:left-auto md:right-auto md:w-96 md:mx-auto`}
      style={{ direction: 'rtl' }}
    >
      <div
        className={`rounded-lg shadow-lg p-4 flex items-center gap-3 ${
          isOnline
            ? 'bg-green-50 border border-green-200'
            : 'bg-amber-50 border border-amber-200'
        }`}
      >
        <div
          className={`w-10 h-10 rounded-full flex items-center justify-center ${
            isOnline ? 'bg-green-100' : 'bg-amber-100'
          }`}
        >
          {isOnline ? (
            <Wifi className="w-5 h-5 text-green-600" />
          ) : (
            <WifiOff className="w-5 h-5 text-amber-600" />
          )}
        </div>

        <div className="flex-1">
          <p className={`font-medium text-sm ${isOnline ? 'text-green-800' : 'text-amber-800'}`}>
            {isOnline ? 'تم استعادة الاتصال بالإنترنت' : 'أنت في وضع عدم الاتصال'}
          </p>
          <p className={`text-xs mt-0.5 ${isOnline ? 'text-green-600' : 'text-amber-600'}`}>
            {isOnline
              ? 'يمكنك متابعة التسوق بشكل طبيعي'
              : 'سيتم حفظ بياناتك ومزامنتها لاحقاً'}
          </p>
        </div>

        {!isOnline && (
          <button
            onClick={handleRetry}
            className="p-2 rounded-lg bg-amber-100 hover:bg-amber-200 transition-colors"
            title="إعادة المحاولة"
          >
            <RefreshCw className="w-4 h-4 text-amber-700" />
          </button>
        )}

        <button
          onClick={() => setShowBanner(false)}
          className={`text-sm font-medium ${
            isOnline ? 'text-green-700 hover:text-green-800' : 'text-amber-700 hover:text-amber-800'
          }`}
        >
          إغلاق
        </button>
      </div>
    </div>
  );
};

export default OfflineNotification;
